/*
 * Copyright (c) Worldline 2022.
 */

import {Component, Input, OnInit} from '@angular/core';
import {ExternalEvidenceTempDataStatus} from "../../constant/external-evidence-temp-data-status";
import {SharedService} from "../../services/shared.service";
import {PopoverMode} from "../../constant/popover-mode";
import {EvidenceService} from "../../services/evidence.service";
import {EvidenceContentType} from "../../constant/evidence-content-type";
import {NgxSpinnerService} from "ngx-spinner";
import {Errors} from "../../constant/errors";
import {DomSanitizer} from "@angular/platform-browser";
import {ActivatedRoute, NavigationStart, Router} from "@angular/router";
import {filter} from "rxjs";
import {RootScopeService} from "../../services/rootscope.service";
import {SignerService} from "../../services/signer.service";
import {EvidenceUserHelperService} from "../../services/evidence-user-helper.service";
import {HttpService} from "../../http/http.service";

@Component({
    selector: 'app-wl-evidence-to-crop',
    templateUrl: './wl-evidence-to-crop.component.html'
})
export class WlEvidenceToCropComponent implements OnInit {

    constructor(public rootScope: RootScopeService,
                private route: ActivatedRoute,
                private sharedService: SharedService,
                private spinnerService: NgxSpinnerService,
                private evidenceService: EvidenceService,
                private domSanitize: DomSanitizer,
                private router: Router,
                private signersService: SignerService,
                private evidenceUserHelperService: EvidenceUserHelperService,
                private http: HttpService) {
    }

    @Input()
    evidenceWithTemp: any;

    @Input()
    nbPages: any

    openPopoverEvidenceToCrop: any;
    currentTempPage: any;
    evidenceContentType: any;
    popoverMode: any;
    newPartIndex: any;
    dataToReplace: any;
    imageCropLink: any;
    croppingMsg: any;
    affectInProgress = false;
    partIndex: any

    private sessionId: any;
    private signerId: any;
    private evidence: any;
    private tempEvidence: any;
    private croppingAllowed = false;
    private initialWidth: any
    private initialHeight: any;
    private croppingData: any;
    private cbOnSelectEnd;
    private onSelectChange;

    ngOnInit(): void {
        const that = this;

        this.sessionId = this.route.snapshot.params['sessionId'];
        this.signerId = this.signersService.currentSigner.extSignerId;
        this.evidence = this.evidenceWithTemp.evidenceDto;
        this.tempEvidence = this.evidenceWithTemp.evidenceTempDataDto;

        if (this.evidenceWithTemp.evidenceTempDataDto.externalEvidenceTempDataStatus === ExternalEvidenceTempDataStatus.TO_CROP || this.evidenceWithTemp.evidenceTempDataDto.externalEvidenceTempDataStatus === ExternalEvidenceTempDataStatus.TO_CROP_AND_AFFECTATION) {
            this.croppingAllowed = true;
        }

        for (var i = 0; i < this.evidenceWithTemp.evidenceDto.parts.length; i++) {
            if (this.evidenceWithTemp.evidenceDto.parts[i].extEvidencePartId === this.evidenceWithTemp.evidenceTempDataDto.extEvidencePartId) {
                this.evidenceWithTemp.evidenceDto.parts[i].uploadDate = null;
                this.partIndex = i;
            }
        }

        if (typeof (this.rootScope.get().popoverTable) === 'undefined') {
            this.evidenceUserHelperService.createPopoverTable();
        }

        //Add keys on popover table
        for (var j = 0; j < this.evidenceWithTemp.evidenceDto.parts.length; j++) {
            this.evidenceUserHelperService.registerPopoverButton('help-affectChoiceButton_' + j);
        }
        this.evidenceUserHelperService.registerPopoverButton('help-affectChoiceButtonKeep1');
        this.evidenceUserHelperService.registerPopoverButton('help-affectChoiceButtonKeep2');

        //Update scope from the rootScope
        this.openPopoverEvidenceToCrop = this.rootScope.get().openPopover;

        //Initialise currentTempPage
        if (typeof (this.currentTempPage) === 'undefined') {
            this.currentTempPage = this.tempEvidence.lastPageProcessed + 1;
        }

        console.debug('evidence to crop : ' + this.tempEvidence.extEvidenceId + ' type is ' + this.evidence.evidenceType.type);

        //Pass enums constants to html
        this.evidenceContentType = EvidenceContentType;
        this.popoverMode = PopoverMode;

        //Pass number of possible documents dispatch to the front
        if (this.evidenceWithTemp.evidenceDto.evidenceContentType === EvidenceContentType.MULTI) {
            this.getNumberOfPartAvailable(); //Get number of available parts
            this.newPartIndex = this.evidenceWithTemp.evidenceDto.parts.length + 1; //New index for the button
        }

        that.cbOnSelectEnd = function (img, selection) {
            console.debug('Selection is ', selection);

            if (selection.width === 0 || selection.height === 0) {
                //In case of the cropping section size is 0 => All image must be selected
                that.croppingData = {
                    'startX': 0,
                    'startY': 0,
                    'endX': that.initialWidth,
                    'endY': that.initialHeight,
                    'rot': '0'
                };
            } else {
                that.croppingData = {
                    'startX': selection.x1,
                    'startY': selection.y1,
                    'endX': selection.x2,
                    'endY': selection.y2,
                    'rot': '0'
                };
            }
            console.debug('Cropping data kept', that.croppingData);


        };

        that.onSelectChange = function (img, selection) {
            console.debug('CHANGE => x1=' + selection.x1 + ' y1=' + selection.y1 + ' x2=' + selection.x2 + ' y2=' + selection.y2);
        };

        window.addEventListener('resize', function () {
            if (that.croppingAllowed) {
                that.imgAreaSelectRepositioning();
            }
        });

        this.router.events.pipe(
            filter(e => e instanceof NavigationStart)
        ).subscribe(() => {
            this.cleanImgAreaSelect()
        });
        // this.sharedService.on('$includeContentRequested', this.cleanImgAreaSelect);

        //A part have been affected, change page
        this.sharedService.on('partAffected', function (event) {
            console.debug('part ' + event.data.part.extEvidencePartId + ' affected with page ' + that.currentTempPage);
            that.spinnerService.hide('spinner');

            that.affectInProgress = false;

            //Do not show the popover anymore
            that.evidenceUserHelperService.closeAll();

            if (that.currentTempPage < that.nbPages) {
                var oldPart = false;
                // Update old part in the scope
                for (var i = 0; i < that.evidenceWithTemp.evidenceDto.parts.length; i++) {
                    if (that.evidenceWithTemp.evidenceDto.parts[i].extEvidencePartId === event.data.part.extEvidencePartId) {
                        that.evidenceWithTemp.evidenceDto.parts[i] = event.data.part;
                        oldPart = true;
                    }
                }
                //Update new part
                if (oldPart === false) {
                    that.evidenceWithTemp.evidenceDto.parts[that.evidenceWithTemp.evidenceDto.parts.length] = event.data.part;
                }
                //If it is not the last part to upload
                if (that.evidenceWithTemp.evidenceDto.parts.length < that.evidenceWithTemp.evidenceDto.maxPartNumber) {
                    that.newPartIndex = that.evidenceWithTemp.evidenceDto.parts.length + 1;
                } else {
                    that.sharedService.broadcast('affectTerminated', null);
                }
                that.currentTempPage++;
                that.getNumberOfPartAvailable(); //Get number of available parts
                that.showEvidenceToCrop();
            } else {
                that.sharedService.broadcast('affectTerminated', null);
            }
        });

        that.showEvidenceToCrop();

    }

    sendCroppingData(extEvidencePartId) {
        const that = this;
        if (!this.affectInProgress) {
            this.spinnerService.show('spinner');
            this.affectInProgress = true;

            //Do not show the popover anymore
            this.evidenceUserHelperService.closeAll();

            console.debug('affecting page ' + this.currentTempPage + ' to part ' + extEvidencePartId);

            if (!this.croppingAllowed) {
                this.croppingData = null;
            }
            this.evidenceService.affectTempData(this.sessionId, this.signerId, this.tempEvidence.extEvidenceId, extEvidencePartId, this.croppingData, this.currentTempPage)
                .then(function (response) {
                    that.spinnerService.hide('spinner');
                    that.croppingMsg = response;
                }, function (error) {
                    that.spinnerService.hide('spinner');
                    console.warn(error);
                });
        }
    };

    skipCropping() {
        const that = this;
        //If an affect is in progress
        if (!this.affectInProgress) {
            console.debug('skip cropping page');

            this.spinnerService.show('spinner');
            this.affectInProgress = true;

            //Do not show the popover anymore
            this.evidenceUserHelperService.closeAll();

            //Skip page
            this.http.skipTempDataPage(this.sessionId, this.signerId, this.tempEvidence.extEvidenceId, this.currentTempPage)
                .toPromise()
                .then(function (response) {
                    that.spinnerService.hide('spinner');
                    that.affectInProgress = false;
                    if (response?.success) {
                        if (that.currentTempPage < that.nbPages) {
                            that.currentTempPage++;
                            that.showEvidenceToCrop();
                        } else {
                            that.sharedService.broadcast('affectTerminated', null);
                        }
                    } else {
                        console.warn(response?.error?.msg);
                        //Find the correct error
                        switch (response?.error?.errorCode) {
                            case Errors.invalidAction :
                                that.croppingMsg = 'cropping.error.invalid-action';
                                break;
                        }
                    }
                }, function (error) {
                    that.spinnerService.hide('spinner');
                    that.affectInProgress = false;
                    console.warn(error);
                    that.croppingMsg = error;
                });
        }
    };

    //Get number of available parts
    private getNumberOfPartAvailable() {
        var nbPartUploaded = 0;
        var numberOfDispatchMissing;

        for (var i = 0; i < this.evidenceWithTemp.evidenceDto.parts.length; i++) {
            if (this.evidenceWithTemp.evidenceDto.parts[i].uploadDate !== null) {
                nbPartUploaded++;
            }
        }
        numberOfDispatchMissing = this.evidenceWithTemp.evidenceDto.maxPartNumber - nbPartUploaded;

        this.dataToReplace = {
            MAX: this.evidenceWithTemp.evidenceDto.maxPartNumber,
            REMAINING: numberOfDispatchMissing
        };
    }

    //Defines
    private showEvidenceToCrop() {
        const that = this;
        //load displayed img with final "css" size
        let evImg = document.getElementsByClassName('evToCrop')[0]
        let promise1 = new Promise<void>(resolve => {
            evImg.addEventListener('load', function () {
                resolve();
            })
        });

        //determine original image size ---------
        var testImage = new Image();
        //prevent cache problem with random value
        var url = window.URL || window.webkitURL;
        this.http.getEvidenceTemp(this.sessionId, this.signerId, this.tempEvidence.extEvidenceId, this.currentTempPage)
            .toPromise()
            .then(function (response) {
                var blobUrl = url.createObjectURL(response);
                that.imageCropLink = that.domSanitize.bypassSecurityTrustUrl(blobUrl);
                testImage.src = blobUrl;

                let promise2 = new Promise<void>(resolve => {
                    testImage.onload = function () {
                        that.initialHeight = testImage.height;
                        that.initialWidth = testImage.width;
                        console.debug('Image size: Width:' + that.initialWidth + ' Height: ' + that.initialHeight);
                        resolve()
                    };
                });

                if (that.croppingAllowed) {

                    //all: init imgareaselect
                    Promise.all([promise1, promise2]).then(function () {
                        ($('.evToCrop') as any).imgAreaSelect({
                            instance: true,
                            show: true,
                            handles: true,
                            persistent: false,
                            imageHeight: that.initialHeight,
                            imageWidth: that.initialWidth,
                            x1: 0, y1: 0, x2: that.initialWidth - 1, y2: that.initialHeight,
                            onSelectEnd: that.cbOnSelectEnd,
                            onSelectChange: that.onSelectChange
                        });
                    });
                }
            });

    }

    //remove jquery component on navigation
    private cleanImgAreaSelect() {
        ($('.evToCrop') as any).imgAreaSelect({remove: true})
    }

    //repositioning of image selection area
    private imgAreaSelectRepositioning() {
        var evImg = document.getElementsByClassName('evToCrop')[0]
        var width, height;

        //Get back image dimensions
        width = evImg.getAttribute('width');
        height = evImg.getAttribute('height');

        ($('.evToCrop') as any).imgAreaSelect({
            instance: true,
            show: true,
            handles: true,
            persistent: false,
            imageWidth: width,
            imageHeight: height,
            x1: 0, y1: 0, x2: width - 1, y2: height,
            onSelectEnd: this.cbOnSelectEnd,
            onSelectChange: this.onSelectChange

        });
    }
}
